// extracted by mini-css-extract-plugin
module.exports = {"__button":"ButtonCancel___button_s9Z9D","__cancel":"ButtonCancel___cancel_22v1T"};